import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Axios from "../../axiosInstance";
import {  motorApiEndpoints } from "../../../api";
import { toast } from "sonner";

const initialState = {
  CurrentPolicyNumber: "",
  NewQuoteNumber: "",
  CancellationResponse: [],
  QuoteWithRefundDetails:  [],
  AdjustSumInsuredResponse : [],
  isCancellationLoading: false,
  isQuoteWithRefundLoading: false,
  isAdjustSumInsuredLoading: false,
  success: null,
  error: null,
  isInspectionDocsUploaded: true,
  isInspectionFailed: false,
  isDamagePhotoTaken: false,
  damageCheckbox: "",
  isRejectedEndorsementLoading: false,
  rejectEndorsementResponse: "",
  isEndEndorsementLoading: false,
  endEndorsementResponse: "",
};

// Helper to create a timeout promise
const timeoutPromise = (ms) => {
    return new Promise((_, reject) =>
      setTimeout(() => reject(new Error('Request timed out')), ms)
    );
  };
  

export const cancelPolicy = createAsyncThunk(
    "cancelPolicy",
    async (payload, { rejectWithValue }) => {
        try {
            console.log("Calling cancel policy...")
            const response = await Promise.race([
                Axios.post(`${motorApiEndpoints.cancelPolicy}`, payload), timeoutPromise(1000), // 5 seconds timeout
            ]);
            console.log("Cancel policy response is: ", response.data)

            return response.data;
        } catch (err) {
          if (err.message =='Request timed out') {
            toast.error("Request time out.");
            return rejectWithValue({ error: 'Request timed out' });
          }
          else {
            toast.error("Error in cancelling policy", err);
          }
            return rejectWithValue(err.response.data);
        }
    }
);

export const rejectCancelPolicy = createAsyncThunk(
    "rejectCancelPolicy",
    async (payload, { rejectWithValue }) => {
        try {
            console.log("Calling cancel policy...")
            const response = await Axios.post(`${motorApiEndpoints.rejectCancelPolicy}`, payload);
            console.log("Cancel policy response is: ", response.data)

            return response.data;
        } catch (err) {
            toast.error("Error in rejecting cancel policy:", err);
            return rejectWithValue(err.response.data);
        }
    }
);
export const getQuoteWithRefund = createAsyncThunk(
    "getQuoteWithRefund",
    async (payload, { rejectWithValue }) => {
        try {
            console.log("Calling getQuoteWithRefund with payload: ", payload)
            const response = await Axios.post(`${motorApiEndpoints.getQuoteWithRefund}`, payload);
            console.log("getQuoteWithRefund response is: ", response.data)

            return response.data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

export const adjustSumInsured = createAsyncThunk(
  "adjustSumInsured",
  async (payload, { rejectWithValue }) => {
      try {
          console.log("Calling adjustSumInsured with payload: ", payload)
          const response = await Axios.post(`${motorApiEndpoints.adjustSumInsured}`, payload);
          console.log("adjustSumInsured response is: ", response.data)

          return response.data;
      } catch (err) {
          toast.error("Error in adjusting sum insured:", err);
          return rejectWithValue(err.response.data);
      }
  }
);


export const rejectEndorsement = createAsyncThunk(
  "rejectEndorsement",
  async (payload, { rejectWithValue }) => {
      try {
          console.log("Calling rejectEndorsement with payload: ", payload)
          const response = await Axios.post(`${motorApiEndpoints.rejectEndorsement}`, payload);
          console.log("rejectEndorsement response is: ", response.data)

          return response.data;
      } catch (err) {
          // toast.error("Error in rejectEndorsement:", err);
          return rejectWithValue(err.response.data);
      }
  }
);

export const endEndorsement = createAsyncThunk(
  "endEndorsement",
  async (payload, { rejectWithValue }) => {
      try {
          console.log("Calling endEndorsement with payload: ", payload)
          const response = await Axios.post(`${motorApiEndpoints.endEndorsement}`, payload);
          console.log("endEndorsement response is: ", response.data)

          return response.data;
      } catch (err) {
          // toast.error("Error in rejectEndorsement:", err);
          return rejectWithValue(err.response.data);
      }
  }
);


export const cancellationSlice = createSlice({
  name: "cancellationSlice",
  initialState,
  reducers: {
    clearCancellationError: (state) => {
      state.error = null;
      state.rejectEndorsementResponse = null;
    },
    setIsInspectionDocsUploaded: (state, action) => {
      state.isInspectionDocsUploaded = action.payload;
    },
    setIsDamagePhotosTaken: (state, action) => {
      state.isDamagePhotoTaken = action.payload;
    },
    setDamageCheckbox: (state, action) => {
      state.damageCheckbox = action.payload;
    },
    setIsInspectionFailed: (state, action) => {
      state.isInspectionFailed = action.payload;
    },
    clearCancellationState: (state) => initialState
  },
  extraReducers: (builder) => {
    // Cancel Active Policy (Make it cancellation in progress) API
    builder.addCase(cancelPolicy.pending, (state, action) => {
      if (!state.data) {
        state.isCancellationLoading = true;
      }
    });
    builder.addCase(cancelPolicy.fulfilled, (state, action) => {
      state.isCancellationLoading = false;
      state.success = true;
      state.error = null;
      state.CancellationResponse = action?.payload;
    });
    builder.addCase(cancelPolicy.rejected, (state, action) => {
      state.isCancellationLoading = false;
      state.error = action.payload?.ErrorMessageEn;
      state.success = false;
      console.log("Get quote error: ", action.payload.ErrorMessageEn )
      toast.error("Get quote errors: " + action.payload.ErrorMessageEn);
    });
    // Get quote with refund API
    builder.addCase(getQuoteWithRefund.pending, (state, action) => {
      console.log('cover prices is pending....');
      if (!state.data) {
        state.isQuoteWithRefundLoading = true;
      }
    });
    builder.addCase(getQuoteWithRefund.fulfilled, (state, action) => {
      state.isQuoteWithRefundLoading = false;
      state.success = true;
      state.error = null;
      state.QuoteWithRefundDetails = action?.payload;
      state.NewQuoteNumber = action?.payload.QuoteNumber;
    });
    builder.addCase(getQuoteWithRefund.rejected, (state, action) => {
      state.isQuoteWithRefundLoading = false;
      state.success = false;
      state.error = action.payload;

      // Extract and display error message
      const errorMessage = action.payload?.ErrorMessageEn || "An error occurred";
      toast.error(errorMessage);
    });
     // Reject Cancellation API
     builder.addCase(rejectCancelPolicy.pending, (state, action) => {
        if (!state.data) {
          state.isCancellationLoading = true;
        }
      });
      builder.addCase(rejectCancelPolicy.fulfilled, (state, action) => {
        state.isCancellationLoading = false;
        state.success = true;
        state.error = null;
        state.CancellationResponse = action?.payload;
      });
      builder.addCase(rejectCancelPolicy.rejected, (state, action) => {
        state.isCancellationLoading = false;
        state.error = action.payload?.ErrorMessageEn;
        state.success = false;
        console.log("Get quote error: ", action.payload.ErrorMessageEn )
        toast.error("Get quote errors: " + action.payload.ErrorMessageEn);
      });
      // Adjust Sum Insured API
      builder.addCase(adjustSumInsured.pending, (state, action) => {
        if (!state.data) {
          state.isAdjustSumInsuredLoading = true;
        }
      });
      builder.addCase(adjustSumInsured.fulfilled, (state, action) => {
        state.isAdjustSumInsuredLoading = false;
        state.success = true;
        state.error = null;
        state.AdjustSumInsuredResponse = action?.payload;
      });
      builder.addCase(adjustSumInsured.rejected, (state, action) => {
        state.isAdjustSumInsuredLoading = false;
        state.error = action.payload?.ErrorMessageEn;
        state.success = false;
        console.log("adjustSumInsured error: ", action.payload.ErrorMessageEn)
      });
      // Reject Endorsement API
      builder.addCase(rejectEndorsement.pending, (state, action) => {
        if (!state.data) {
          state.isRejectedEndorsementLoading = true;
        }
      });
      builder.addCase(rejectEndorsement.fulfilled, (state, action) => {
        state.isRejectedEndorsementLoading = false;
        state.success = true;
        state.error = null;
        state.rejectEndorsementResponse = action?.payload?.ErrorMessageEn;
      });
      builder.addCase(rejectEndorsement.rejected, (state, action) => {
        state.isRejectedEndorsementLoading = false;
        state.error = action.payload?.ErrorMessageEn;
        state.success = false;
        state.rejectEndorsementResponse = action?.payload?.ErrorMessageEn;
        console.log("adjustSumInsured error: ", action.payload.ErrorMessageEn)
      });
      // End Endorsement API
      builder.addCase(endEndorsement.pending, (state, action) => {
        if (!state.data) {
          state.isEndEndorsementLoading = true;
        }
      });
      builder.addCase(endEndorsement.fulfilled, (state, action) => {
        state.isEndEndorsementLoading = false;
        state.success = true;
        state.error = null;
        state.endEndorsementResponse = action?.payload?.ErrorMessageEn;
      });
      builder.addCase(endEndorsement.rejected, (state, action) => {
        state.isEndEndorsementLoading = false;
        state.error = action.payload?.ErrorMessageEn;
        state.success = false;
        state.endEndorsementResponse = action?.payload?.ErrorMessageEn;
        console.log("End endorsement error: ", action.payload.ErrorMessageEn)
      });

  },
});

// SELECTORS
export const getQuoteWithRefundResponse = (store) => store?.cancellationApi.QuoteWithRefundDetails;
export const getQuoteWithRefundDetailsResponse = (store) => store?.cancellationApi.QuoteWithRefundDetails.QuoteDetails;

export const getCancellationResponse = (store) => store?.cancellationApi.CancellationResponse;

export const CurrentPolicyNumberResponse = (store) => store?.cancellationApi.CurrentPolicyNumber;
export const NewQuoteNumberResponse = (store) => store?.cancellationApi.NewQuoteNumber;

export const getCancelLoading = (store) => store?.cancellationApi.isCancellationLoading;
export const getQuoteWithRefundLoading = (store) => store?.cancellationApi.isQuoteWithRefundLoading;

export const getQuoteWithRefundError = (store) => store?.cancellationApi.error;
export const getCancellationError = (store) => store?.cancellationApi.error;
export const getCancellationSuccess = (store) => store?.cancellationApi.success;

export const getInspectionDocsUploaded = (store) => store?.cancellationApi.isInspectionDocsUploaded;
export const getInspectionFailed = (store) => store?.cancellationApi.isInspectionFailed;

export const getIsDamagePhotoTaken = (store) => store?.cancellationApi.isDamagePhotoTaken;
export const getDamageCheckbox = (store) => store?.cancellationApi.damageCheckbox;

export const getAdjustSumInsuredResponse = (store) => store?.cancellationApi.AdjustSumInsuredResponse;
export const getAdjustSumInsuredLoading = (store) => store?.cancellationApi.isAdjustSumInsuredLoading;

export const getRejectEndorsementResponse = (store) => store?.cancellationApi.rejectEndorsementResponse;
export const getRejectEndorsementLoading = (store) => store?.cancellationApi.isRejectedEndorsementLoading;

export const getEndEndorsementResponse = (store) => store?.cancellationApi.endEndorsementResponse;
export const getEndEndorsementLoading = (store) => store?.cancellationApi.isEndEndorsementLoading;



// ACTIONS TO DISPATCH
export const { clearCancellationError, clearCancellationState, setIsInspectionFailed, 
               setIsInspectionDocsUploaded, setIsDamagePhotosTaken, setDamageCheckbox } = cancellationSlice.actions;

export default cancellationSlice.reducer;
